import React from 'react'
import {NavLink, useParams} from 'react-router-dom'

import Textimage from '../Components/Text+image';
import CenterTextImage from '../Components/Text+imageCenter';
import Gallery from '../Components/Gallery'
import Island from '../Components/Island';

import AppearOnScroll from '../Components/AppearOnScroll';
import Button from '../Components/Button';
import ArrowLeft from '../Components/icons/ArrowLeft';


export default function Project() {
    let {projectName} = useParams();

    let projects = require("../projects.json");

    let project = projects.filter(project => project.project_name === projectName)[0];

  return (
      
        <div className={"relative overflow-hidden"}>
            <section className='flex flex-col pt-32 md:pt-48 xl:pt-52 px-4 md:px-16 lg:px-24 xl:px-48 gap-12 md:gap-16 xl:gap-24 pb-24 w-full overflow-x-hidden'>
                  <AppearOnScroll y={60}>
                  <div className='flex flex-col gap-12 items-start'>
                        <div className='flex flex-col items-start gap-4 w-full xl:w-80'>
                        <NavLink to={`/#Projects`} state={{ scrollTo: "Projects" }}>
                        <Button icon={ArrowLeft} iconPosition="left" variant="breadcrumb" className='group'>Back</Button>
                        </NavLink>      
                              <h1 className='font-display font-medium leading-relaxed  text-3xl md:text-5xl xl:text-7xl text-dark text-wrap text-left cursor-default'>{project.project_title}</h1>
                        </div>
                        <AppearOnScroll delay={0.3}>
                        <div className='w-full flex flex-col gap-4 items-start'>
                              <h3 className='font-display font-medium text-2xl xl:text-2xl text-left'>Overview</h3>
                              <p  className='lg:w-60 xl:w-50 text-left leading-relaxed font-body font-normal text-lg xl:text-xl'>{project.summary}</p>
                              {project.link ?  
                              <a href={project.link} target="_blank">
                              <Button icon={""} iconPosition="left" variant="breadcrumb" className='group'>Watch project video</Button></a>
                              : <></>}
                              
                        </div>
                        </AppearOnScroll>
                        <AppearOnScroll delay={0.4}>
                        <div className='flex flex-row align-middle w-full items-center justify-center aspect-[4/3] lg:aspect-[calc(4/4*2)] overflow-hidden rounded-image'>
                        <img src={`/img/${project.folder}/${project.main_image}`} alt='projects overview' className="w-full object-cover"/>
                        </div>
                        </AppearOnScroll>
                  <div className='flex w-full lg:justify-end'>
                  <div className={` grid grid-cols-1 lg:grid-cols-2 gap-2 md:gap-8 xl:gap-12 cursor-default lg:w-40 align-end`}>
                        <AppearOnScroll>
                        <div className='flex flex-col align-top text-left gap-2 '>
                              <h3 className='font-display font-medium text-xl xl:text-2xl'>Client</h3>
                              <h3 className="font-body font-regular text-lg xl:text-xl text-dark">{project.client}</h3>
                        </div>
                        </AppearOnScroll>
                        <AppearOnScroll delay={0.3}>
                        <div className='flex flex-col items-start text-left gap-2'>
                              <h3 className='font-display font-medium text-xl xl:text-2xl'>My role</h3>
                              <h3 className="font-body font-regular text-lg xl:text-xl text-dark">{project.role}</h3>
                        </div>
                        </AppearOnScroll>
                        <AppearOnScroll delay={0.4}>
                        <div className='flex flex-col items-start text-left gap-2'>
                              <h3 className='font-display font-medium text-xl xl:text-2xl'>Project</h3>
                              <h3 className="font-body font-regular text-lg xl:text-xl text-dark">{project.keywords}</h3>
                        </div>
                        </AppearOnScroll>
                        <AppearOnScroll delay={0.5}>
                        <div className='flex flex-col items-start text-left gap-2'>
                              <h3 className='font-display font-medium text-xl xl:text-2xl'>Completed</h3>
                              <h3 className="font-body font-regular text-lg xl:text-xl text-dark">{project.duration}</h3>
                        </div>
                        </AppearOnScroll>
                  </div>
                  </div>
                  </div>
                  </AppearOnScroll>
                  
                  
                  <div>
                  {project.challenge.map(section => (
                  <AppearOnScroll>
                  <Textimage
                  pill={section.pill}
                  heading={section.title}
                  info={section.text}
                  image={section.image}
                        
                  /> 
                  </AppearOnScroll>
                  ))}
                  </div>
                  <div className='flex flex-col'>
                  {project.Strategy.map(section => (
                        <CenterTextImage
                        pill={section.pill}
                        info={section.text}
                        image={section.image}
                  /> 
                  ))}
                  </div>
                  <div className='flex flex-col gap-16'>
                  {project.changes.map(section => (
                        <Textimage
                        pill={section.pill}
                        heading={section.title}
                        info={section.text}
                        image={section.image}
                  /> 
                  ))}
                  </div>
                  
                  <Gallery/>
                  <div className='flex flex-col gap-12 pb-24'>
                  <Island>{project.reflection}</Island>
                  <div className='content-initial'>
                  <NavLink to={`/#Projects`} state={{ scrollTo: "Projects" }}> 
                  <Button icon={ArrowLeft} iconPosition="left" variant="secondary" className='group'>Back to projects</Button>
                  </NavLink>
                  </div>
                  
                  </div>
                  
            </section>
             
        </div>
      
  )
}
